import { type DeviceType } from '@cx-modules/types';

export type OffersClickoutServiceInput = {
  clickoutUrl: string;
  currentPathWithRepub: string;
  deviceType: DeviceType;
  fullPageUrl: string;
  gtmId: string;
};

/**
 * Pure derivation of the offers-clickout service props. Astro-ward (NGF-6268): this module must not
 * read provider context — callers inject the request-scoped values (sourced from
 * ComponentLoaderContext and the global ENV) instead.
 */
export const getOffersClickoutServiceProps = ({
  clickoutUrl,
  currentPathWithRepub,
  deviceType,
  fullPageUrl,
  gtmId,
}: OffersClickoutServiceInput) => ({
  clickoutService: 'OFFERS_CLICKOUT_SERVICE' as const,
  clickoutServiceUrl: `${clickoutUrl}/offer/clickout`,
  pageUrl: currentPathWithRepub,
  deviceType,
  gtmId,
  fullPageUrl,
});
